export default __webpack_public_path__ + "static/media/cgm-device.b5fa99cd.png";